import React from 'react';
import { Route } from 'react-router-dom';
// import OfferResponseByOffer from './ndc/offer/OfferResponseByOffer.js'
// import OfferResponseByUri from "./ndc/offer/OfferResponseByUri.js";
import TripPlanner from './ndc/offer/TripPlanner.js';
import { useAuth0 } from '@auth0/auth0-react';
import './App.css';

// const Root = () => (
//   <div className="root">
//     <h2>Welcome</h2>
//     <a href="#/offer-response/http%3A%2F%2Fross.consulting%2FgetOffersResponse%2Fsabre%2F2020-01-20T11%3A19%3A55.232%2Ffcd53dba-906c-4415-9ef5-23aecdbfefbb">
//       Example offer Bluesky
//     </a>
//     <br />
//     {/* <a href="#/offer-response/http%3A%2F%2Fross.consulting%2FgetOffersResponse%2Ftravelstart%2F2018-04-16T13%3A04%3A47%2Fa9b21d50-185d-4f07-b613-090db41482fb">
//       Example offer Travelstart
//     </a> */}
//     <br />
//   </div>
// );

const NavWrapper = ({ children }) => {
  let { isAuthenticated, logout } = useAuth0();

  return (
    <React.Fragment>
      <header>
        <nav className='navbar navbar-nx'>
          <div className='container'>
            <div className='navbar-header'>
              <button
                type='button'
                className='navbar-toggle collapsed hamburger hamburger--slider js-hamburger'
                data-toggle='collapse'
                data-target='#main_navbar'
                aria-expanded='false'
                aria-controls='navbar'
              >
                <span className='icon-bar'></span>
                <span className='icon-bar'></span>
                <span className='icon-bar'></span>
              </button>
              <a className='navbar-brand' title='transend' style={{ display: 'inline-block' }}></a>
              <div style={{ height: '80px', float: 'right', paddingTop: '1.5em' }}>
                {isAuthenticated && (
                  <button
                    className='btn btn-outline btn-danger'
                    onClick={() =>
                      logout({
                        returnTo: window.location.origin,
                      })
                    }
                  >
                    Log Out
                  </button>
                )}
                {/* <!-- <a class="collapsed mi-bef searchbtn" data-toggle="collapse" data-target="#search_col" aria-expanded="false" aria-controls="navbar"></a> --> */}
              </div>
            </div>
            <div id='main_navbar' className='collapse navbar-collapse'>
              {/* <ul className='nav navbar-nav navbar-right login-info'>
                <li className='dropdown' style={{ paddingTop: '1.5em' }}>
                   <a href='#' className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>
                  Roderick Ross
                </a>
                <ul className='dropdown-menu'>
                  <li>
                    <a href='#'>My Profile</a>
                  </li>
                  <li>
                    <a href='#'>Log out</a>
                  </li>
                </ul> 
                </li>
              </ul>*/}

              {/* <!--    <ul class="nav navbar-nav navbar-left main-nav"> 
       <li class="dropdown"><a href="/ncdsimple/#/" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Dashboard</a>
        </li> 
   <li class="dropdown">
          <a
            href="/ncdsimple/#/offer-response/"
            class="dropdown-toggle selected"
            data-toggle="dropdown"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            >Plan a Trip</a
          >
        </li> -->
      <!-- <li class="dropdown"><a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">My Trips &amp; Expenses</a>
         <ul class="dropdown-menu">
           <li><a href="#">Booking Activity</a></li>
           <li><a href="#">Expense Claims</a></li>
         </ul>
        </li>
        <li class="dropdown"><a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Reports</a>
         <ul class="dropdown-menu">
           <li><a href="#">Overview</a></li>
           <li><a href="#">Profiles</a></li>
           <li><a href="#">Destination</a></li>
           <li><a href="#">Vendor</a></li>
           <li><a href="#">Trips Report</a></li>
           <li><a href="#">Travel Tracker</a></li>
         </ul>
        </li>
        <li><a href="#">Alerts</a></li>
        <li class="dropdown"><a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Profiles</a>
         <ul class="dropdown-menu">
           <li><a href="#">Dashboard</a></li>
           <li><a href="#">Departments</a></li>
           <li><a href="#">Divisions</a></li>
           <li><a href="#">Grades</a></li>
           <li><a href="#">Labels</a></li>
         </ul>
        </li>
        <li class="dropdown"><a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Settings</a>
         <ul class="dropdown-menu">
           <li><a href="#">Policies</a></li>
           <li><a href="#">Exchange Rates</a></li>
           <li><a href="#">Credit Cards</a></li>
           <li><a href="#">Travel Reasons</a></li>
           <li><a href="#">Expense Groups</a></li>
           <li><a href="#">Cost Centers</a></li>
           <li><a href="#">Expense Types</a></li>
         </ul>
        </li>
       </ul>  --> */}
            </div>
          </div>
        </nav>
      </header>
      {children}
    </React.Fragment>
  );
};

const loadingImg = 'https://cdn.auth0.com/blog/auth0-react-sample/assets/loading.svg';

const App = () => {
  let { isAuthenticated, isLoading, loginWithRedirect, error} = useAuth0();

  if (isLoading) {
    return (
      <NavWrapper>
        <div className='ndc-simple-app container'>
          <img src={loadingImg} alt='Loading...' style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', marginTop: '10%' }} />
        </div>
      </NavWrapper>
    );
  }

  if (error) {
    let errorDesc = error.error_description === "Please verify your email before logging in." ? "Please check your email and click on the verification link before logging in." : error.error_description;
    return (
      <NavWrapper>
        <div className='ndc-simple-app container' style={{ width: '300px' }}>
          <h2 className='text-center'>Welcome to Trans-End!</h2>
          <h4 style={{ color: '#d9534f' }}>
            <br /> {errorDesc}
            <br />
            <br />
          </h4>
          <button className='btn btn-primary btn-block' onClick={() => loginWithRedirect()}>
            Log In
          </button>
          <button
            className='btn btn-primary btn-block'
            onClick={() =>
              loginWithRedirect({
                screen_hint: 'signup',
              })
            }
          >
            Sign Up
          </button>
        </div>
      </NavWrapper>
    );
  }

  if (!isAuthenticated) {
    return (
      <NavWrapper>
        <div className='ndc-simple-app container' style={{ width: '300px' }}>
          <h2 className='text-center'>Welcome to Trans-End!</h2>
          <h4>
            <br /> Please login or create an account to continue.
            <br />
            <br />
          </h4>
          <button className='btn btn-primary btn-block' onClick={() => loginWithRedirect()}>
            Log In
          </button>
          <button
            className='btn btn-primary btn-block'
            onClick={() =>
              loginWithRedirect({
                screen_hint: 'signup',
              })
            }
          >
            Sign Up
          </button>
        </div>
      </NavWrapper>
    );
  }

  return (
    <NavWrapper>
      <div className='ndc-simple-app container'>
        {/* <Route path="/" exact={true} component={Root} /> */}
        <Route path='/' exact={true} component={(props) => <TripPlanner newTrip={'https://www.trans-end.com'} {...props} />} />
        {/* <Route path="/ba-new" component={props => <TripPlanner newTrip={"https://www.ba.com"} {...props} />} /> */}
        {/* <Route path="/transend-new" component={props => <TripPlanner newTrip={"https://www.trans-end.com"} {...props} />} /> */}
        {/* <Route path='/offer/:offerUri' component={TripPlanner} /> */}
        <Route path='/compactOffer/:compactOfferUri/:compactOfferKey' component={TripPlanner} />
        {/* <Route path="/offer-response-old/:offersResponseURI" component={OfferResponseByUri} /> */}
        <Route path="/offer-response/:offersResponseURI?" component={TripPlanner} />{' '}
      </div>
    </NavWrapper>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js